/**
 * AttachmentSheet (06 §4.10) — icon tiles: Document, Photos & Videos, Camera,
 * Contact. Desktop popover / mobile bottom sheet (BottomSheet primitive).
 */
import { FileText, Image, Camera, User } from 'lucide-react';
import { BottomSheet } from '../primitives/Overlays';
import styles from './AttachmentSheet.module.css';

export type AttachKind = 'Document' | 'Photos & Videos' | 'Camera' | 'Contact';

interface Props {
  open: boolean;
  onClose: () => void;
  onPick: (kind: AttachKind) => void;
}

const TILES: { kind: AttachKind; icon: React.ReactNode; color: string }[] = [
  { kind: 'Document', icon: <FileText size={22} />, color: '#5157ae' },
  { kind: 'Photos & Videos', icon: <Image size={22} />, color: '#bf59cf' },
  { kind: 'Camera', icon: <Camera size={22} />, color: '#d3396d' },
  { kind: 'Contact', icon: <User size={22} />, color: '#0796d3' },
];

export function AttachmentSheet({ open, onClose, onPick }: Props) {
  return (
    <BottomSheet open={open} onClose={onClose}>
      <div className={styles.grid}>
        {TILES.map((t) => (
          <button key={t.kind} className={styles.tile} onClick={() => onPick(t.kind)}>
            <span className={styles.icon} style={{ background: t.color }}>
              {t.icon}
            </span>
            <span className={styles.label}>{t.kind}</span>
          </button>
        ))}
      </div>
    </BottomSheet>
  );
}
